import "./App.css";
import PageContainer from "./components/PageContainer/PageContainer";
import "./App.css";
import Testimonials from "./pages/Testimonials/Testimonials";
import NavContainer from "./components/NavContainer/NavContainer";

function Apps() {
    return (
        <NavContainer>
            <PageContainer />
        </NavContainer>
    );
}

export default Apps;
